import {useAppState} from "@nutastic/nutastic-react-app";
import { CONSTANTS } from '../utils/constants';

/**
 * @typedef NuStationDataHookValues
 * @property {function(slug:string)} getMusicProjectIdBySlug - get the ID of a music project
 * @property {function(slug:string)} getVideoIdBySlug - get the ID of video by slug
 * @property {function(slug:string)} getArtistIdBySlug - get the ID of artist by slug
 * @property {function(slug:string)} getArtistBySlug - get the artist by slug
 * @property {function(slug:string)} getVideoBySlug - get video by slug
 * @property musicLibrary - available music collection
 * @property artistLibrary - list of creative artists
 * @property videoLibrary - available video collection
 */
/**
 *
 * @returns {NuStationDataHookValues}
 */
const useNuStationData = () => {
  const { nuData = {}, content } = useAppState();
  const { slugMap = {} } = nuData;
  const { videos, artists, musicCollection } = content;

  const getMusicProjectIdBySlug = slug => {
    if (slugMap.hasOwnProperty(CONSTANTS.APPKEY_MUSIC)) {
      return slugMap[CONSTANTS.APPKEY_MUSIC][slug];
    }
    return null;
  }

  const getVideoIdBySlug = slug => {
    if (slugMap.hasOwnProperty(CONSTANTS.APPKEY_VIDEOS)) {
      return slugMap[CONSTANTS.APPKEY_VIDEOS][slug];
    }
    return null;
  }

  const getVideoBySlug = slug => {
    return (videos || []).find(v => v.hasOwnProperty('slug') && v.slug === slug);
  };

  const getArtistIdBySlug = slug => {
    if (slugMap.hasOwnProperty(CONSTANTS.APPKEY_ARTIST)) {
      return slugMap[CONSTANTS.APPKEY_ARTIST][slug];
    }
    return null;
  }

  const getArtistBySlug = slug => {
    return (artists || []).find(a => a.hasOwnProperty('slug') && a.slug === slug);
  };

  return {
    getMusicProjectIdBySlug,
    getVideoIdBySlug,
    getArtistIdBySlug,
    getArtistBySlug,
    getVideoBySlug,
    artistLibrary: artists,
    musicLibrary: musicCollection,
    videoLibrary: videos
  };
};

export {
  useNuStationData
};
